export class Money {
  cents: number;
  currency_iso: string;
}
